/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as CalendarsRouteImport } from './routes/calendars'
import { Route as CarriersRouteImport } from './routes/carriers'
import { Route as DeliveriesRouteImport } from './routes/deliveries'
import { Route as FxRatesRouteImport } from './routes/fx-rates'
import { Route as LaneCapacitiesRouteImport } from './routes/lane-capacities'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ModesRouteImport } from './routes/modes'
import { Route as PriorityPoliciesRouteImport } from './routes/priority-policies'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as SelectTenantRouteImport } from './routes/select-tenant'
import { Route as SitesRouteImport } from './routes/sites'
import { Route as SolverConfigurationRouteImport } from './routes/solver-configuration'
import { Route as AdminMembersRouteImport } from './routes/admin.members'
import { Route as AdminPlanningScopesRouteImport } from './routes/admin.planning-scopes'
import { Route as AdminQueueRouteImport } from './routes/admin.queue'
import { Route as AnalyticsCompareRouteImport } from './routes/analytics.compare'
import { Route as AnalyticsExplainRouteImport } from './routes/analytics.explain'
import { Route as AnalyticsFindingsRouteImport } from './routes/analytics.findings'
import { Route as AnalyticsSavingsRouteImport } from './routes/analytics.savings'
import { Route as AnalyticsSpendRouteImport } from './routes/analytics.spend'
import { Route as AuditUiEditRouteImport } from './routes/audit.ui-edit'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as DataIndexRouteImport } from './routes/data.index'
import { Route as DataFeedDrivenRouteImport } from './routes/data.feed-driven'
import { Route as DataManuallyManagedRouteImport } from './routes/data.manually-managed'
import { Route as DeliveriesIndexRouteImport } from './routes/deliveries.index'
import { Route as DeliveriesDeliveryIdRouteImport } from './routes/deliveries.$deliveryId'
import { Route as DemandBookedLoadsRouteImport } from './routes/demand.booked-loads'
import { Route as DemandReservedCapacityRouteImport } from './routes/demand.reserved-capacity'
import { Route as DemandTransferRequestsRouteImport } from './routes/demand.transfer-requests'
import { Route as DevCoverageRouteImport } from './routes/dev.coverage'
import { Route as ExperimentsIndexRouteImport } from './routes/experiments.index'
import { Route as ExperimentsScenarioIdRouteImport } from './routes/experiments.$scenarioId'
import { Route as ExperimentsCompareRouteImport } from './routes/experiments.compare'
import { Route as KccOverridesRouteImport } from './routes/kcc.overrides'
import { Route as KccSalesForecastsRouteImport } from './routes/kcc.sales-forecasts'
import { Route as KccSalesOrdersRouteImport } from './routes/kcc.sales-orders'
import { Route as KccSalesPlanningRouteImport } from './routes/kcc.sales-planning'
import { Route as LaneWorkspaceIndexRouteImport } from './routes/lane-workspace.index'
import { Route as LaneWorkspaceLaneIdRouteImport } from './routes/lane-workspace.$laneId'
import { Route as OutboundIndexRouteImport } from './routes/outbound.index'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsInboundLaneDetailRouteImport } from './routes/reports.inbound-lane-detail'
import { Route as ReportsLaneDaysDriftRouteImport } from './routes/reports.lane-days-drift'
import { Route as ReportsLaneDetailRouteImport } from './routes/reports.lane-detail'
import { Route as ReportsMapRouteImport } from './routes/reports.map'
import { Route as ReportsProductDetailRouteImport } from './routes/reports.product-detail'
import { Route as RunsIndexRouteImport } from './routes/runs.index'
import { Route as RunsRunIdRouteImport } from './routes/runs.$runId'
import { Route as SiteWorkspaceIndexRouteImport } from './routes/site-workspace.index'
import { Route as SiteWorkspaceSiteIdRouteImport } from './routes/site-workspace.$siteId'
import { Route as UploadsIndexRouteImport } from './routes/uploads.index'
import { Route as UploadsUploadIdRouteImport } from './routes/uploads.$uploadId'
import { Route as DataIssuesIndexRouteImport } from './routes/data.issues.index'
import { Route as DataIssuesIssueIdRouteImport } from './routes/data.issues.$issueId'
import { Route as OutboundSnapshotsSnapshotIdRouteImport } from './routes/outbound.snapshots.$snapshotId'
import { Route as PlanningIssuesIndexRouteImport } from './routes/planning.issues.index'
import { Route as PlanningIssuesIssueIdRouteImport } from './routes/planning.issues.$issueId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarsRoute = CalendarsRouteImport.update({
  id: '/calendars',
  path: '/calendars',
  getParentRoute: () => rootRouteImport,
} as any)
const CarriersRoute = CarriersRouteImport.update({
  id: '/carriers',
  path: '/carriers',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveriesRoute = DeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => rootRouteImport,
} as any)
const FxRatesRoute = FxRatesRouteImport.update({
  id: '/fx-rates',
  path: '/fx-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const LaneCapacitiesRoute = LaneCapacitiesRouteImport.update({
  id: '/lane-capacities',
  path: '/lane-capacities',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ModesRoute = ModesRouteImport.update({
  id: '/modes',
  path: '/modes',
  getParentRoute: () => rootRouteImport,
} as any)
const PriorityPoliciesRoute = PriorityPoliciesRouteImport.update({
  id: '/priority-policies',
  path: '/priority-policies',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectTenantRoute = SelectTenantRouteImport.update({
  id: '/select-tenant',
  path: '/select-tenant',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesRoute = SitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const SolverConfigurationRoute = SolverConfigurationRouteImport.update({
  id: '/solver-configuration',
  path: '/solver-configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMembersRoute = AdminMembersRouteImport.update({
  id: '/admin/members',
  path: '/admin/members',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlanningScopesRoute = AdminPlanningScopesRouteImport.update({
  id: '/admin/planning-scopes',
  path: '/admin/planning-scopes',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminQueueRoute = AdminQueueRouteImport.update({
  id: '/admin/queue',
  path: '/admin/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsCompareRoute = AnalyticsCompareRouteImport.update({
  id: '/analytics/compare',
  path: '/analytics/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsExplainRoute = AnalyticsExplainRouteImport.update({
  id: '/analytics/explain',
  path: '/analytics/explain',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsFindingsRoute = AnalyticsFindingsRouteImport.update({
  id: '/analytics/findings',
  path: '/analytics/findings',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsSavingsRoute = AnalyticsSavingsRouteImport.update({
  id: '/analytics/savings',
  path: '/analytics/savings',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsSpendRoute = AnalyticsSpendRouteImport.update({
  id: '/analytics/spend',
  path: '/analytics/spend',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditUiEditRoute = AuditUiEditRouteImport.update({
  id: '/ui-edit',
  path: '/ui-edit',
  getParentRoute: () => AuditRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DataIndexRoute = DataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataFeedDrivenRoute = DataFeedDrivenRouteImport.update({
  id: '/data/feed-driven',
  path: '/data/feed-driven',
  getParentRoute: () => rootRouteImport,
} as any)
const DataManuallyManagedRoute = DataManuallyManagedRouteImport.update({
  id: '/data/manually-managed',
  path: '/data/manually-managed',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveriesIndexRoute = DeliveriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DeliveriesRoute,
} as any)
const DeliveriesDeliveryIdRoute = DeliveriesDeliveryIdRouteImport.update({
  id: '/$deliveryId',
  path: '/$deliveryId',
  getParentRoute: () => DeliveriesRoute,
} as any)
const DemandBookedLoadsRoute = DemandBookedLoadsRouteImport.update({
  id: '/demand/booked-loads',
  path: '/demand/booked-loads',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandReservedCapacityRoute = DemandReservedCapacityRouteImport.update({
  id: '/demand/reserved-capacity',
  path: '/demand/reserved-capacity',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandTransferRequestsRoute = DemandTransferRequestsRouteImport.update({
  id: '/demand/transfer-requests',
  path: '/demand/transfer-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCoverageRoute = DevCoverageRouteImport.update({
  id: '/dev/coverage',
  path: '/dev/coverage',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsIndexRoute = ExperimentsIndexRouteImport.update({
  id: '/experiments/',
  path: '/experiments/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsScenarioIdRoute = ExperimentsScenarioIdRouteImport.update({
  id: '/experiments/$scenarioId',
  path: '/experiments/$scenarioId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsCompareRoute = ExperimentsCompareRouteImport.update({
  id: '/experiments/compare',
  path: '/experiments/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const KccOverridesRoute = KccOverridesRouteImport.update({
  id: '/kcc/overrides',
  path: '/kcc/overrides',
  getParentRoute: () => rootRouteImport,
} as any)
const KccSalesForecastsRoute = KccSalesForecastsRouteImport.update({
  id: '/kcc/sales-forecasts',
  path: '/kcc/sales-forecasts',
  getParentRoute: () => rootRouteImport,
} as any)
const KccSalesOrdersRoute = KccSalesOrdersRouteImport.update({
  id: '/kcc/sales-orders',
  path: '/kcc/sales-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const KccSalesPlanningRoute = KccSalesPlanningRouteImport.update({
  id: '/kcc/sales-planning',
  path: '/kcc/sales-planning',
  getParentRoute: () => rootRouteImport,
} as any)
const LaneWorkspaceIndexRoute = LaneWorkspaceIndexRouteImport.update({
  id: '/lane-workspace/',
  path: '/lane-workspace/',
  getParentRoute: () => rootRouteImport,
} as any)
const LaneWorkspaceLaneIdRoute = LaneWorkspaceLaneIdRouteImport.update({
  id: '/lane-workspace/$laneId',
  path: '/lane-workspace/$laneId',
  getParentRoute: () => rootRouteImport,
} as any)
const OutboundIndexRoute = OutboundIndexRouteImport.update({
  id: '/outbound/',
  path: '/outbound/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsInboundLaneDetailRoute =
  ReportsInboundLaneDetailRouteImport.update({
    id: '/reports/inbound-lane-detail',
    path: '/reports/inbound-lane-detail',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsLaneDaysDriftRoute = ReportsLaneDaysDriftRouteImport.update({
  id: '/reports/lane-days-drift',
  path: '/reports/lane-days-drift',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsLaneDetailRoute = ReportsLaneDetailRouteImport.update({
  id: '/reports/lane-detail',
  path: '/reports/lane-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsMapRoute = ReportsMapRouteImport.update({
  id: '/reports/map',
  path: '/reports/map',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsProductDetailRoute = ReportsProductDetailRouteImport.update({
  id: '/reports/product-detail',
  path: '/reports/product-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRunIdRoute = RunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteWorkspaceIndexRoute = SiteWorkspaceIndexRouteImport.update({
  id: '/site-workspace/',
  path: '/site-workspace/',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteWorkspaceSiteIdRoute = SiteWorkspaceSiteIdRouteImport.update({
  id: '/site-workspace/$siteId',
  path: '/site-workspace/$siteId',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadsIndexRoute = UploadsIndexRouteImport.update({
  id: '/uploads/',
  path: '/uploads/',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadsUploadIdRoute = UploadsUploadIdRouteImport.update({
  id: '/uploads/$uploadId',
  path: '/uploads/$uploadId',
  getParentRoute: () => rootRouteImport,
} as any)
const DataIssuesIndexRoute = DataIssuesIndexRouteImport.update({
  id: '/data/issues/',
  path: '/data/issues/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataIssuesIssueIdRoute = DataIssuesIssueIdRouteImport.update({
  id: '/data/issues/$issueId',
  path: '/data/issues/$issueId',
  getParentRoute: () => rootRouteImport,
} as any)
const OutboundSnapshotsSnapshotIdRoute =
  OutboundSnapshotsSnapshotIdRouteImport.update({
    id: '/outbound/snapshots/$snapshotId',
    path: '/outbound/snapshots/$snapshotId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlanningIssuesIndexRoute = PlanningIssuesIndexRouteImport.update({
  id: '/planning/issues/',
  path: '/planning/issues/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanningIssuesIssueIdRoute = PlanningIssuesIssueIdRouteImport.update({
  id: '/planning/issues/$issueId',
  path: '/planning/issues/$issueId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/audit': typeof AuditRouteWithChildren
  '/calendars': typeof CalendarsRoute
  '/carriers': typeof CarriersRoute
  '/deliveries': typeof DeliveriesRouteWithChildren
  '/fx-rates': typeof FxRatesRoute
  '/lane-capacities': typeof LaneCapacitiesRoute
  '/login': typeof LoginRoute
  '/modes': typeof ModesRoute
  '/priority-policies': typeof PriorityPoliciesRoute
  '/products': typeof ProductsRoute
  '/select-tenant': typeof SelectTenantRoute
  '/sites': typeof SitesRoute
  '/solver-configuration': typeof SolverConfigurationRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/planning-scopes': typeof AdminPlanningScopesRoute
  '/admin/queue': typeof AdminQueueRoute
  '/analytics/compare': typeof AnalyticsCompareRoute
  '/analytics/explain': typeof AnalyticsExplainRoute
  '/analytics/findings': typeof AnalyticsFindingsRoute
  '/analytics/savings': typeof AnalyticsSavingsRoute
  '/analytics/spend': typeof AnalyticsSpendRoute
  '/audit/ui-edit': typeof AuditUiEditRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/data/feed-driven': typeof DataFeedDrivenRoute
  '/data/manually-managed': typeof DataManuallyManagedRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/demand/booked-loads': typeof DemandBookedLoadsRoute
  '/demand/reserved-capacity': typeof DemandReservedCapacityRoute
  '/demand/transfer-requests': typeof DemandTransferRequestsRoute
  '/dev/coverage': typeof DevCoverageRoute
  '/experiments/$scenarioId': typeof ExperimentsScenarioIdRoute
  '/experiments/compare': typeof ExperimentsCompareRoute
  '/kcc/overrides': typeof KccOverridesRoute
  '/kcc/sales-forecasts': typeof KccSalesForecastsRoute
  '/kcc/sales-orders': typeof KccSalesOrdersRoute
  '/kcc/sales-planning': typeof KccSalesPlanningRoute
  '/lane-workspace/$laneId': typeof LaneWorkspaceLaneIdRoute
  '/reports/inbound-lane-detail': typeof ReportsInboundLaneDetailRoute
  '/reports/lane-days-drift': typeof ReportsLaneDaysDriftRoute
  '/reports/lane-detail': typeof ReportsLaneDetailRoute
  '/reports/map': typeof ReportsMapRoute
  '/reports/product-detail': typeof ReportsProductDetailRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/site-workspace/$siteId': typeof SiteWorkspaceSiteIdRoute
  '/uploads/$uploadId': typeof UploadsUploadIdRoute
  '/data/': typeof DataIndexRoute
  '/deliveries/': typeof DeliveriesIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/lane-workspace/': typeof LaneWorkspaceIndexRoute
  '/outbound/': typeof OutboundIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/site-workspace/': typeof SiteWorkspaceIndexRoute
  '/uploads/': typeof UploadsIndexRoute
  '/data/issues/$issueId': typeof DataIssuesIssueIdRoute
  '/outbound/snapshots/$snapshotId': typeof OutboundSnapshotsSnapshotIdRoute
  '/planning/issues/$issueId': typeof PlanningIssuesIssueIdRoute
  '/data/issues/': typeof DataIssuesIndexRoute
  '/planning/issues/': typeof PlanningIssuesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/audit': typeof AuditRouteWithChildren
  '/calendars': typeof CalendarsRoute
  '/carriers': typeof CarriersRoute
  '/fx-rates': typeof FxRatesRoute
  '/lane-capacities': typeof LaneCapacitiesRoute
  '/login': typeof LoginRoute
  '/modes': typeof ModesRoute
  '/priority-policies': typeof PriorityPoliciesRoute
  '/products': typeof ProductsRoute
  '/select-tenant': typeof SelectTenantRoute
  '/sites': typeof SitesRoute
  '/solver-configuration': typeof SolverConfigurationRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/planning-scopes': typeof AdminPlanningScopesRoute
  '/admin/queue': typeof AdminQueueRoute
  '/analytics/compare': typeof AnalyticsCompareRoute
  '/analytics/explain': typeof AnalyticsExplainRoute
  '/analytics/findings': typeof AnalyticsFindingsRoute
  '/analytics/savings': typeof AnalyticsSavingsRoute
  '/analytics/spend': typeof AnalyticsSpendRoute
  '/audit/ui-edit': typeof AuditUiEditRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/data/feed-driven': typeof DataFeedDrivenRoute
  '/data/manually-managed': typeof DataManuallyManagedRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/demand/booked-loads': typeof DemandBookedLoadsRoute
  '/demand/reserved-capacity': typeof DemandReservedCapacityRoute
  '/demand/transfer-requests': typeof DemandTransferRequestsRoute
  '/dev/coverage': typeof DevCoverageRoute
  '/experiments/$scenarioId': typeof ExperimentsScenarioIdRoute
  '/experiments/compare': typeof ExperimentsCompareRoute
  '/kcc/overrides': typeof KccOverridesRoute
  '/kcc/sales-forecasts': typeof KccSalesForecastsRoute
  '/kcc/sales-orders': typeof KccSalesOrdersRoute
  '/kcc/sales-planning': typeof KccSalesPlanningRoute
  '/lane-workspace/$laneId': typeof LaneWorkspaceLaneIdRoute
  '/reports/inbound-lane-detail': typeof ReportsInboundLaneDetailRoute
  '/reports/lane-days-drift': typeof ReportsLaneDaysDriftRoute
  '/reports/lane-detail': typeof ReportsLaneDetailRoute
  '/reports/map': typeof ReportsMapRoute
  '/reports/product-detail': typeof ReportsProductDetailRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/site-workspace/$siteId': typeof SiteWorkspaceSiteIdRoute
  '/uploads/$uploadId': typeof UploadsUploadIdRoute
  '/data': typeof DataIndexRoute
  '/deliveries': typeof DeliveriesIndexRoute
  '/experiments': typeof ExperimentsIndexRoute
  '/lane-workspace': typeof LaneWorkspaceIndexRoute
  '/outbound': typeof OutboundIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/runs': typeof RunsIndexRoute
  '/site-workspace': typeof SiteWorkspaceIndexRoute
  '/uploads': typeof UploadsIndexRoute
  '/data/issues/$issueId': typeof DataIssuesIssueIdRoute
  '/outbound/snapshots/$snapshotId': typeof OutboundSnapshotsSnapshotIdRoute
  '/planning/issues/$issueId': typeof PlanningIssuesIssueIdRoute
  '/data/issues': typeof DataIssuesIndexRoute
  '/planning/issues': typeof PlanningIssuesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/audit': typeof AuditRouteWithChildren
  '/calendars': typeof CalendarsRoute
  '/carriers': typeof CarriersRoute
  '/deliveries': typeof DeliveriesRouteWithChildren
  '/fx-rates': typeof FxRatesRoute
  '/lane-capacities': typeof LaneCapacitiesRoute
  '/login': typeof LoginRoute
  '/modes': typeof ModesRoute
  '/priority-policies': typeof PriorityPoliciesRoute
  '/products': typeof ProductsRoute
  '/select-tenant': typeof SelectTenantRoute
  '/sites': typeof SitesRoute
  '/solver-configuration': typeof SolverConfigurationRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/planning-scopes': typeof AdminPlanningScopesRoute
  '/admin/queue': typeof AdminQueueRoute
  '/analytics/compare': typeof AnalyticsCompareRoute
  '/analytics/explain': typeof AnalyticsExplainRoute
  '/analytics/findings': typeof AnalyticsFindingsRoute
  '/analytics/savings': typeof AnalyticsSavingsRoute
  '/analytics/spend': typeof AnalyticsSpendRoute
  '/audit/ui-edit': typeof AuditUiEditRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/data/feed-driven': typeof DataFeedDrivenRoute
  '/data/manually-managed': typeof DataManuallyManagedRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/demand/booked-loads': typeof DemandBookedLoadsRoute
  '/demand/reserved-capacity': typeof DemandReservedCapacityRoute
  '/demand/transfer-requests': typeof DemandTransferRequestsRoute
  '/dev/coverage': typeof DevCoverageRoute
  '/experiments/$scenarioId': typeof ExperimentsScenarioIdRoute
  '/experiments/compare': typeof ExperimentsCompareRoute
  '/kcc/overrides': typeof KccOverridesRoute
  '/kcc/sales-forecasts': typeof KccSalesForecastsRoute
  '/kcc/sales-orders': typeof KccSalesOrdersRoute
  '/kcc/sales-planning': typeof KccSalesPlanningRoute
  '/lane-workspace/$laneId': typeof LaneWorkspaceLaneIdRoute
  '/reports/inbound-lane-detail': typeof ReportsInboundLaneDetailRoute
  '/reports/lane-days-drift': typeof ReportsLaneDaysDriftRoute
  '/reports/lane-detail': typeof ReportsLaneDetailRoute
  '/reports/map': typeof ReportsMapRoute
  '/reports/product-detail': typeof ReportsProductDetailRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/site-workspace/$siteId': typeof SiteWorkspaceSiteIdRoute
  '/uploads/$uploadId': typeof UploadsUploadIdRoute
  '/data/': typeof DataIndexRoute
  '/deliveries/': typeof DeliveriesIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/lane-workspace/': typeof LaneWorkspaceIndexRoute
  '/outbound/': typeof OutboundIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/site-workspace/': typeof SiteWorkspaceIndexRoute
  '/uploads/': typeof UploadsIndexRoute
  '/data/issues/$issueId': typeof DataIssuesIssueIdRoute
  '/outbound/snapshots/$snapshotId': typeof OutboundSnapshotsSnapshotIdRoute
  '/planning/issues/$issueId': typeof PlanningIssuesIssueIdRoute
  '/data/issues/': typeof DataIssuesIndexRoute
  '/planning/issues/': typeof PlanningIssuesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/audit'
    | '/calendars'
    | '/carriers'
    | '/deliveries'
    | '/fx-rates'
    | '/lane-capacities'
    | '/login'
    | '/modes'
    | '/priority-policies'
    | '/products'
    | '/select-tenant'
    | '/sites'
    | '/solver-configuration'
    | '/admin/members'
    | '/admin/planning-scopes'
    | '/admin/queue'
    | '/analytics/compare'
    | '/analytics/explain'
    | '/analytics/findings'
    | '/analytics/savings'
    | '/analytics/spend'
    | '/audit/ui-edit'
    | '/auth/callback'
    | '/data/feed-driven'
    | '/data/manually-managed'
    | '/deliveries/$deliveryId'
    | '/demand/booked-loads'
    | '/demand/reserved-capacity'
    | '/demand/transfer-requests'
    | '/dev/coverage'
    | '/experiments/$scenarioId'
    | '/experiments/compare'
    | '/kcc/overrides'
    | '/kcc/sales-forecasts'
    | '/kcc/sales-orders'
    | '/kcc/sales-planning'
    | '/lane-workspace/$laneId'
    | '/reports/inbound-lane-detail'
    | '/reports/lane-days-drift'
    | '/reports/lane-detail'
    | '/reports/map'
    | '/reports/product-detail'
    | '/runs/$runId'
    | '/site-workspace/$siteId'
    | '/uploads/$uploadId'
    | '/data/'
    | '/deliveries/'
    | '/experiments/'
    | '/lane-workspace/'
    | '/outbound/'
    | '/reports/'
    | '/runs/'
    | '/site-workspace/'
    | '/uploads/'
    | '/data/issues/$issueId'
    | '/outbound/snapshots/$snapshotId'
    | '/planning/issues/$issueId'
    | '/data/issues/'
    | '/planning/issues/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/audit'
    | '/calendars'
    | '/carriers'
    | '/fx-rates'
    | '/lane-capacities'
    | '/login'
    | '/modes'
    | '/priority-policies'
    | '/products'
    | '/select-tenant'
    | '/sites'
    | '/solver-configuration'
    | '/admin/members'
    | '/admin/planning-scopes'
    | '/admin/queue'
    | '/analytics/compare'
    | '/analytics/explain'
    | '/analytics/findings'
    | '/analytics/savings'
    | '/analytics/spend'
    | '/audit/ui-edit'
    | '/auth/callback'
    | '/data/feed-driven'
    | '/data/manually-managed'
    | '/deliveries/$deliveryId'
    | '/demand/booked-loads'
    | '/demand/reserved-capacity'
    | '/demand/transfer-requests'
    | '/dev/coverage'
    | '/experiments/$scenarioId'
    | '/experiments/compare'
    | '/kcc/overrides'
    | '/kcc/sales-forecasts'
    | '/kcc/sales-orders'
    | '/kcc/sales-planning'
    | '/lane-workspace/$laneId'
    | '/reports/inbound-lane-detail'
    | '/reports/lane-days-drift'
    | '/reports/lane-detail'
    | '/reports/map'
    | '/reports/product-detail'
    | '/runs/$runId'
    | '/site-workspace/$siteId'
    | '/uploads/$uploadId'
    | '/data'
    | '/deliveries'
    | '/experiments'
    | '/lane-workspace'
    | '/outbound'
    | '/reports'
    | '/runs'
    | '/site-workspace'
    | '/uploads'
    | '/data/issues/$issueId'
    | '/outbound/snapshots/$snapshotId'
    | '/planning/issues/$issueId'
    | '/data/issues'
    | '/planning/issues'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/audit'
    | '/calendars'
    | '/carriers'
    | '/deliveries'
    | '/fx-rates'
    | '/lane-capacities'
    | '/login'
    | '/modes'
    | '/priority-policies'
    | '/products'
    | '/select-tenant'
    | '/sites'
    | '/solver-configuration'
    | '/admin/members'
    | '/admin/planning-scopes'
    | '/admin/queue'
    | '/analytics/compare'
    | '/analytics/explain'
    | '/analytics/findings'
    | '/analytics/savings'
    | '/analytics/spend'
    | '/audit/ui-edit'
    | '/auth/callback'
    | '/data/feed-driven'
    | '/data/manually-managed'
    | '/deliveries/$deliveryId'
    | '/demand/booked-loads'
    | '/demand/reserved-capacity'
    | '/demand/transfer-requests'
    | '/dev/coverage'
    | '/experiments/$scenarioId'
    | '/experiments/compare'
    | '/kcc/overrides'
    | '/kcc/sales-forecasts'
    | '/kcc/sales-orders'
    | '/kcc/sales-planning'
    | '/lane-workspace/$laneId'
    | '/reports/inbound-lane-detail'
    | '/reports/lane-days-drift'
    | '/reports/lane-detail'
    | '/reports/map'
    | '/reports/product-detail'
    | '/runs/$runId'
    | '/site-workspace/$siteId'
    | '/uploads/$uploadId'
    | '/data/'
    | '/deliveries/'
    | '/experiments/'
    | '/lane-workspace/'
    | '/outbound/'
    | '/reports/'
    | '/runs/'
    | '/site-workspace/'
    | '/uploads/'
    | '/data/issues/$issueId'
    | '/outbound/snapshots/$snapshotId'
    | '/planning/issues/$issueId'
    | '/data/issues/'
    | '/planning/issues/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AuditRoute: typeof AuditRouteWithChildren
  CalendarsRoute: typeof CalendarsRoute
  CarriersRoute: typeof CarriersRoute
  DeliveriesRoute: typeof DeliveriesRouteWithChildren
  FxRatesRoute: typeof FxRatesRoute
  LaneCapacitiesRoute: typeof LaneCapacitiesRoute
  LoginRoute: typeof LoginRoute
  ModesRoute: typeof ModesRoute
  PriorityPoliciesRoute: typeof PriorityPoliciesRoute
  ProductsRoute: typeof ProductsRoute
  SelectTenantRoute: typeof SelectTenantRoute
  SitesRoute: typeof SitesRoute
  SolverConfigurationRoute: typeof SolverConfigurationRoute
  AdminMembersRoute: typeof AdminMembersRoute
  AdminPlanningScopesRoute: typeof AdminPlanningScopesRoute
  AdminQueueRoute: typeof AdminQueueRoute
  AnalyticsCompareRoute: typeof AnalyticsCompareRoute
  AnalyticsExplainRoute: typeof AnalyticsExplainRoute
  AnalyticsFindingsRoute: typeof AnalyticsFindingsRoute
  AnalyticsSavingsRoute: typeof AnalyticsSavingsRoute
  AnalyticsSpendRoute: typeof AnalyticsSpendRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  DataFeedDrivenRoute: typeof DataFeedDrivenRoute
  DataManuallyManagedRoute: typeof DataManuallyManagedRoute
  DemandBookedLoadsRoute: typeof DemandBookedLoadsRoute
  DemandReservedCapacityRoute: typeof DemandReservedCapacityRoute
  DemandTransferRequestsRoute: typeof DemandTransferRequestsRoute
  DevCoverageRoute: typeof DevCoverageRoute
  ExperimentsScenarioIdRoute: typeof ExperimentsScenarioIdRoute
  ExperimentsCompareRoute: typeof ExperimentsCompareRoute
  KccOverridesRoute: typeof KccOverridesRoute
  KccSalesForecastsRoute: typeof KccSalesForecastsRoute
  KccSalesOrdersRoute: typeof KccSalesOrdersRoute
  KccSalesPlanningRoute: typeof KccSalesPlanningRoute
  LaneWorkspaceLaneIdRoute: typeof LaneWorkspaceLaneIdRoute
  ReportsInboundLaneDetailRoute: typeof ReportsInboundLaneDetailRoute
  ReportsLaneDaysDriftRoute: typeof ReportsLaneDaysDriftRoute
  ReportsLaneDetailRoute: typeof ReportsLaneDetailRoute
  ReportsMapRoute: typeof ReportsMapRoute
  ReportsProductDetailRoute: typeof ReportsProductDetailRoute
  RunsRunIdRoute: typeof RunsRunIdRoute
  SiteWorkspaceSiteIdRoute: typeof SiteWorkspaceSiteIdRoute
  UploadsUploadIdRoute: typeof UploadsUploadIdRoute
  DataIndexRoute: typeof DataIndexRoute
  ExperimentsIndexRoute: typeof ExperimentsIndexRoute
  LaneWorkspaceIndexRoute: typeof LaneWorkspaceIndexRoute
  OutboundIndexRoute: typeof OutboundIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  RunsIndexRoute: typeof RunsIndexRoute
  SiteWorkspaceIndexRoute: typeof SiteWorkspaceIndexRoute
  UploadsIndexRoute: typeof UploadsIndexRoute
  DataIssuesIssueIdRoute: typeof DataIssuesIssueIdRoute
  OutboundSnapshotsSnapshotIdRoute: typeof OutboundSnapshotsSnapshotIdRoute
  PlanningIssuesIssueIdRoute: typeof PlanningIssuesIssueIdRoute
  DataIssuesIndexRoute: typeof DataIssuesIndexRoute
  PlanningIssuesIndexRoute: typeof PlanningIssuesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendars': {
      id: '/calendars'
      path: '/calendars'
      fullPath: '/calendars'
      preLoaderRoute: typeof CalendarsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carriers': {
      id: '/carriers'
      path: '/carriers'
      fullPath: '/carriers'
      preLoaderRoute: typeof CarriersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deliveries': {
      id: '/deliveries'
      path: '/deliveries'
      fullPath: '/deliveries'
      preLoaderRoute: typeof DeliveriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fx-rates': {
      id: '/fx-rates'
      path: '/fx-rates'
      fullPath: '/fx-rates'
      preLoaderRoute: typeof FxRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lane-capacities': {
      id: '/lane-capacities'
      path: '/lane-capacities'
      fullPath: '/lane-capacities'
      preLoaderRoute: typeof LaneCapacitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modes': {
      id: '/modes'
      path: '/modes'
      fullPath: '/modes'
      preLoaderRoute: typeof ModesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/priority-policies': {
      id: '/priority-policies'
      path: '/priority-policies'
      fullPath: '/priority-policies'
      preLoaderRoute: typeof PriorityPoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-tenant': {
      id: '/select-tenant'
      path: '/select-tenant'
      fullPath: '/select-tenant'
      preLoaderRoute: typeof SelectTenantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solver-configuration': {
      id: '/solver-configuration'
      path: '/solver-configuration'
      fullPath: '/solver-configuration'
      preLoaderRoute: typeof SolverConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/members': {
      id: '/admin/members'
      path: '/admin/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AdminMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/planning-scopes': {
      id: '/admin/planning-scopes'
      path: '/admin/planning-scopes'
      fullPath: '/admin/planning-scopes'
      preLoaderRoute: typeof AdminPlanningScopesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/queue': {
      id: '/admin/queue'
      path: '/admin/queue'
      fullPath: '/admin/queue'
      preLoaderRoute: typeof AdminQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/compare': {
      id: '/analytics/compare'
      path: '/analytics/compare'
      fullPath: '/analytics/compare'
      preLoaderRoute: typeof AnalyticsCompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/explain': {
      id: '/analytics/explain'
      path: '/analytics/explain'
      fullPath: '/analytics/explain'
      preLoaderRoute: typeof AnalyticsExplainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/findings': {
      id: '/analytics/findings'
      path: '/analytics/findings'
      fullPath: '/analytics/findings'
      preLoaderRoute: typeof AnalyticsFindingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/savings': {
      id: '/analytics/savings'
      path: '/analytics/savings'
      fullPath: '/analytics/savings'
      preLoaderRoute: typeof AnalyticsSavingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/spend': {
      id: '/analytics/spend'
      path: '/analytics/spend'
      fullPath: '/analytics/spend'
      preLoaderRoute: typeof AnalyticsSpendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit/ui-edit': {
      id: '/audit/ui-edit'
      path: '/ui-edit'
      fullPath: '/audit/ui-edit'
      preLoaderRoute: typeof AuditUiEditRouteImport
      parentRoute: typeof AuditRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/': {
      id: '/data/'
      path: '/data'
      fullPath: '/data/'
      preLoaderRoute: typeof DataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/feed-driven': {
      id: '/data/feed-driven'
      path: '/data/feed-driven'
      fullPath: '/data/feed-driven'
      preLoaderRoute: typeof DataFeedDrivenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/manually-managed': {
      id: '/data/manually-managed'
      path: '/data/manually-managed'
      fullPath: '/data/manually-managed'
      preLoaderRoute: typeof DataManuallyManagedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deliveries/': {
      id: '/deliveries/'
      path: '/'
      fullPath: '/deliveries/'
      preLoaderRoute: typeof DeliveriesIndexRouteImport
      parentRoute: typeof DeliveriesRoute
    }
    '/deliveries/$deliveryId': {
      id: '/deliveries/$deliveryId'
      path: '/$deliveryId'
      fullPath: '/deliveries/$deliveryId'
      preLoaderRoute: typeof DeliveriesDeliveryIdRouteImport
      parentRoute: typeof DeliveriesRoute
    }
    '/demand/booked-loads': {
      id: '/demand/booked-loads'
      path: '/demand/booked-loads'
      fullPath: '/demand/booked-loads'
      preLoaderRoute: typeof DemandBookedLoadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand/reserved-capacity': {
      id: '/demand/reserved-capacity'
      path: '/demand/reserved-capacity'
      fullPath: '/demand/reserved-capacity'
      preLoaderRoute: typeof DemandReservedCapacityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand/transfer-requests': {
      id: '/demand/transfer-requests'
      path: '/demand/transfer-requests'
      fullPath: '/demand/transfer-requests'
      preLoaderRoute: typeof DemandTransferRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/coverage': {
      id: '/dev/coverage'
      path: '/dev/coverage'
      fullPath: '/dev/coverage'
      preLoaderRoute: typeof DevCoverageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/': {
      id: '/experiments/'
      path: '/experiments'
      fullPath: '/experiments/'
      preLoaderRoute: typeof ExperimentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/$scenarioId': {
      id: '/experiments/$scenarioId'
      path: '/experiments/$scenarioId'
      fullPath: '/experiments/$scenarioId'
      preLoaderRoute: typeof ExperimentsScenarioIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/compare': {
      id: '/experiments/compare'
      path: '/experiments/compare'
      fullPath: '/experiments/compare'
      preLoaderRoute: typeof ExperimentsCompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kcc/overrides': {
      id: '/kcc/overrides'
      path: '/kcc/overrides'
      fullPath: '/kcc/overrides'
      preLoaderRoute: typeof KccOverridesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kcc/sales-forecasts': {
      id: '/kcc/sales-forecasts'
      path: '/kcc/sales-forecasts'
      fullPath: '/kcc/sales-forecasts'
      preLoaderRoute: typeof KccSalesForecastsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kcc/sales-orders': {
      id: '/kcc/sales-orders'
      path: '/kcc/sales-orders'
      fullPath: '/kcc/sales-orders'
      preLoaderRoute: typeof KccSalesOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kcc/sales-planning': {
      id: '/kcc/sales-planning'
      path: '/kcc/sales-planning'
      fullPath: '/kcc/sales-planning'
      preLoaderRoute: typeof KccSalesPlanningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lane-workspace/': {
      id: '/lane-workspace/'
      path: '/lane-workspace'
      fullPath: '/lane-workspace/'
      preLoaderRoute: typeof LaneWorkspaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lane-workspace/$laneId': {
      id: '/lane-workspace/$laneId'
      path: '/lane-workspace/$laneId'
      fullPath: '/lane-workspace/$laneId'
      preLoaderRoute: typeof LaneWorkspaceLaneIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outbound/': {
      id: '/outbound/'
      path: '/outbound'
      fullPath: '/outbound/'
      preLoaderRoute: typeof OutboundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/inbound-lane-detail': {
      id: '/reports/inbound-lane-detail'
      path: '/reports/inbound-lane-detail'
      fullPath: '/reports/inbound-lane-detail'
      preLoaderRoute: typeof ReportsInboundLaneDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/lane-days-drift': {
      id: '/reports/lane-days-drift'
      path: '/reports/lane-days-drift'
      fullPath: '/reports/lane-days-drift'
      preLoaderRoute: typeof ReportsLaneDaysDriftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/lane-detail': {
      id: '/reports/lane-detail'
      path: '/reports/lane-detail'
      fullPath: '/reports/lane-detail'
      preLoaderRoute: typeof ReportsLaneDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/map': {
      id: '/reports/map'
      path: '/reports/map'
      fullPath: '/reports/map'
      preLoaderRoute: typeof ReportsMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/product-detail': {
      id: '/reports/product-detail'
      path: '/reports/product-detail'
      fullPath: '/reports/product-detail'
      preLoaderRoute: typeof ReportsProductDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/': {
      id: '/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/$runId': {
      id: '/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof RunsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-workspace/': {
      id: '/site-workspace/'
      path: '/site-workspace'
      fullPath: '/site-workspace/'
      preLoaderRoute: typeof SiteWorkspaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-workspace/$siteId': {
      id: '/site-workspace/$siteId'
      path: '/site-workspace/$siteId'
      fullPath: '/site-workspace/$siteId'
      preLoaderRoute: typeof SiteWorkspaceSiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uploads/': {
      id: '/uploads/'
      path: '/uploads'
      fullPath: '/uploads/'
      preLoaderRoute: typeof UploadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uploads/$uploadId': {
      id: '/uploads/$uploadId'
      path: '/uploads/$uploadId'
      fullPath: '/uploads/$uploadId'
      preLoaderRoute: typeof UploadsUploadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/issues/': {
      id: '/data/issues/'
      path: '/data/issues'
      fullPath: '/data/issues/'
      preLoaderRoute: typeof DataIssuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/issues/$issueId': {
      id: '/data/issues/$issueId'
      path: '/data/issues/$issueId'
      fullPath: '/data/issues/$issueId'
      preLoaderRoute: typeof DataIssuesIssueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outbound/snapshots/$snapshotId': {
      id: '/outbound/snapshots/$snapshotId'
      path: '/outbound/snapshots/$snapshotId'
      fullPath: '/outbound/snapshots/$snapshotId'
      preLoaderRoute: typeof OutboundSnapshotsSnapshotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planning/issues/': {
      id: '/planning/issues/'
      path: '/planning/issues'
      fullPath: '/planning/issues/'
      preLoaderRoute: typeof PlanningIssuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planning/issues/$issueId': {
      id: '/planning/issues/$issueId'
      path: '/planning/issues/$issueId'
      fullPath: '/planning/issues/$issueId'
      preLoaderRoute: typeof PlanningIssuesIssueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuditRouteChildren {
  AuditUiEditRoute: typeof AuditUiEditRoute
}

const AuditRouteChildren: AuditRouteChildren = {
  AuditUiEditRoute: AuditUiEditRoute,
}

const AuditRouteWithChildren = AuditRoute._addFileChildren(AuditRouteChildren)

interface DeliveriesRouteChildren {
  DeliveriesDeliveryIdRoute: typeof DeliveriesDeliveryIdRoute
  DeliveriesIndexRoute: typeof DeliveriesIndexRoute
}

const DeliveriesRouteChildren: DeliveriesRouteChildren = {
  DeliveriesDeliveryIdRoute: DeliveriesDeliveryIdRoute,
  DeliveriesIndexRoute: DeliveriesIndexRoute,
}

const DeliveriesRouteWithChildren = DeliveriesRoute._addFileChildren(
  DeliveriesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AuditRoute: AuditRouteWithChildren,
  CalendarsRoute: CalendarsRoute,
  CarriersRoute: CarriersRoute,
  DeliveriesRoute: DeliveriesRouteWithChildren,
  FxRatesRoute: FxRatesRoute,
  LaneCapacitiesRoute: LaneCapacitiesRoute,
  LoginRoute: LoginRoute,
  ModesRoute: ModesRoute,
  PriorityPoliciesRoute: PriorityPoliciesRoute,
  ProductsRoute: ProductsRoute,
  SelectTenantRoute: SelectTenantRoute,
  SitesRoute: SitesRoute,
  SolverConfigurationRoute: SolverConfigurationRoute,
  AdminMembersRoute: AdminMembersRoute,
  AdminPlanningScopesRoute: AdminPlanningScopesRoute,
  AdminQueueRoute: AdminQueueRoute,
  AnalyticsCompareRoute: AnalyticsCompareRoute,
  AnalyticsExplainRoute: AnalyticsExplainRoute,
  AnalyticsFindingsRoute: AnalyticsFindingsRoute,
  AnalyticsSavingsRoute: AnalyticsSavingsRoute,
  AnalyticsSpendRoute: AnalyticsSpendRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  DataFeedDrivenRoute: DataFeedDrivenRoute,
  DataManuallyManagedRoute: DataManuallyManagedRoute,
  DemandBookedLoadsRoute: DemandBookedLoadsRoute,
  DemandReservedCapacityRoute: DemandReservedCapacityRoute,
  DemandTransferRequestsRoute: DemandTransferRequestsRoute,
  DevCoverageRoute: DevCoverageRoute,
  ExperimentsScenarioIdRoute: ExperimentsScenarioIdRoute,
  ExperimentsCompareRoute: ExperimentsCompareRoute,
  KccOverridesRoute: KccOverridesRoute,
  KccSalesForecastsRoute: KccSalesForecastsRoute,
  KccSalesOrdersRoute: KccSalesOrdersRoute,
  KccSalesPlanningRoute: KccSalesPlanningRoute,
  LaneWorkspaceLaneIdRoute: LaneWorkspaceLaneIdRoute,
  ReportsInboundLaneDetailRoute: ReportsInboundLaneDetailRoute,
  ReportsLaneDaysDriftRoute: ReportsLaneDaysDriftRoute,
  ReportsLaneDetailRoute: ReportsLaneDetailRoute,
  ReportsMapRoute: ReportsMapRoute,
  ReportsProductDetailRoute: ReportsProductDetailRoute,
  RunsRunIdRoute: RunsRunIdRoute,
  SiteWorkspaceSiteIdRoute: SiteWorkspaceSiteIdRoute,
  UploadsUploadIdRoute: UploadsUploadIdRoute,
  DataIndexRoute: DataIndexRoute,
  ExperimentsIndexRoute: ExperimentsIndexRoute,
  LaneWorkspaceIndexRoute: LaneWorkspaceIndexRoute,
  OutboundIndexRoute: OutboundIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  RunsIndexRoute: RunsIndexRoute,
  SiteWorkspaceIndexRoute: SiteWorkspaceIndexRoute,
  UploadsIndexRoute: UploadsIndexRoute,
  DataIssuesIssueIdRoute: DataIssuesIssueIdRoute,
  OutboundSnapshotsSnapshotIdRoute: OutboundSnapshotsSnapshotIdRoute,
  PlanningIssuesIssueIdRoute: PlanningIssuesIssueIdRoute,
  DataIssuesIndexRoute: DataIssuesIndexRoute,
  PlanningIssuesIndexRoute: PlanningIssuesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
